import { FC, ReactNode } from "react";

import "./styles.scss";

interface Props {
  children: ReactNode;
}

export const Container: FC<Props> = ({ children }) => {
  return (
    <div className="container" id="container">
      {children}
    </div>
  );
};
